import { Layout } from 'components/atoms'
import { InputBuild, SelectBuild } from 'components/molecules'

import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormComplementaryValue } from './form'
import { ViewComplementaryFormProps } from './interfaces'

const ViewComplementaryDataForm: React.FC = () => {
    const { register, watch } = useFormContext<{
        complementary: ViewComplementaryFormProps
    }>()

    return (
        <Layout
            full
            type="container"
            display="grid"
            gap={8}
            data-testid="form-container"
        >
            <Layout
                type="row"
                gutter={{ y: 1.6 }}
                data-testid="form-fields"
                maxH="580px"
                overflow="auto"
            >
                {FormComplementaryValue.map(
                    ({ layout, input, select }, key) => (
                        <Layout {...layout} key={key}>
                            {select ? (
                                <SelectBuild
                                    {...select}
                                    {...register(`complementary.${select.id}`)}
                                    isDisable={true}
                                />
                            ) : (
                                input && (
                                    <InputBuild
                                        {...input}
                                        {...register(
                                            `complementary.${input.id}`,
                                            {
                                                valueAsNumber:
                                                    input.type === 'number'
                                            }
                                        )}
                                        value={
                                            watch(
                                                `complementary.${input.id}`
                                            ) as string
                                        }
                                        isDisable={true}
                                    />
                                )
                            )}
                        </Layout>
                    )
                )}
            </Layout>
        </Layout>
    )
}

export default ViewComplementaryDataForm
